export default __webpack_public_path__ + "01d6266fab9f48e02069c25b6d863ab8.woff";